// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CameraFilledSvg from "@ant-design/icons-svg/es/asn/CameraFilled";
import AntdIcon from '../components/AntdIcon';

var CameraFilled = function CameraFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CameraFilledSvg
  }));
};

CameraFilled.displayName = 'CameraFilled';
export default React.forwardRef(CameraFilled);